import { useAppSelector } from '../../../hooks/useAppStore';
import { useEffectiveTenant } from '../../../hooks/useEffectiveTenant';

// El admin de Imperium es el único de Imperium que sigue reportando: los demás se lo llevan a él.
const PUEDEN_REPORTAR = ['tenant_admin', 'booster_support', 'booster_admin', 'platform_admin'];

/**
 * ⛔ En Imperium ya no se reportan bugs (23/10/2026, decisión de dirección): llegaban más
 * datos mal cargados que fallas. Y tampoco sugerencias: "no saben sugerir". Sin botón
 * "Reportar" en Gustavo ni botones en Mis tickets (queda el historial). El backend también lo corta
 * (`platform/reporteDeBugs.ts`). Soporte y Booster siguen igual.
 */
export function useSinReporteDeBugs(): boolean {
  const role = useAppSelector((s) => s.auth.user?.role);
  const { tenantMode } = useEffectiveTenant();
  return tenantMode === 'native' && !PUEDEN_REPORTAR.includes(role ?? '');
}
